import { createRouter, createWebHistory } from 'vue-router'

import login from '@/router/login/login';
import dashboard from '@/router/module/dashboard/dashboard';
import administration from '@/router/module/administration/administration';
import inventory from '@/router/module/inventory/inventory';
import hrm from '@/router/module/hrm/hrm';
import purchase from '@/router/module/purchase/purchase';
import attendance from '@/router/module/attendance/attendance';
import sales from '@/router/module/sales/sales';
import accounts from '@/router/module/accounts/accounts';
import asset from '@/router/module/asset/asset';
import leave from '@/router/module/leave/leave';
import payroll from '@/router/module/payroll/payroll';
import document from '@/router/module/document/document';
import lc from '@/router/module/lc/lc';
import production from '@/router/module/production/production';
import project from '@/router/module/projects/project';
import masterData from '@/router/module/master/masterData';


const routes = [...administration, ...inventory, ...dashboard, ...login, ...hrm, ...purchase, ...attendance, ...sales, ...accounts, ...asset, ...leave, ...payroll, ...document, ...lc, ...production, ...project, ...masterData];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 } 
  }
})

function ifRouteExist(to) {
  var path =  to.fullPath;
  if (to.fullPath === "/home") {
    return true;
  } else if (to.fullPath === "/home/dashboard") {
    return true;
  } else if (to.name === "module-features") {
    return true;
  } else if (to.fullPath === "/administration/change-password") {
    return true;
  } else if (to.name === "view-purchase-invoice") {
    return true;
  } else if (to.name === "view-purchase-order") {
    return true;
  } else if (to.name === "view-direct-receive") {
    return true;
  } else if (to.name === "view-po-receive") {
    return true;
  } else if (to.name === "view-requisition") {
    return true;
  } else if (to.name === "view-order-invoice") {
    return true;
  } else if (to.name === "view-sale-invoice") {
    return true;
  } else if (to.name === "view-proposal-invoice") {
    return true;
  } else if (to.name === "crm-view-lead") {
    return true;
  } else if (to.name === "asset-record-details") {
    return true;
  } else if (to.name === "acquisition-purchase-records") {
    return true;
  } else if (to.name === "add-acquisition-purchase-received") {
    return true;
  } else if (to.name === "depreciation-record-details") {
    return true;
  } else if (to.name === "preparation-record-details") {
    return true;
  } else if (to.path === "/master-data/setup-product") {
    return true;
  } else if (to.name === "transfer-record-details") {
    return true;
  } else if (to.name === "maintenance-record-details") {
    return true;
  } else if (to.name === "disposal-write-off-record-details") {
    return true;
  } else if (to.name === "register-reports") {
    return true;
  } else if (to.name === "depreciation-schedule-report") {
    return true;
  } else if (to.name === "maintenance-cost-report") {
    return true;
  } else if (to.name === "transfer-history-report") {
    return true;
  } else if (to.name === "disposal-summary-report") {
    return true;
  } else if (to.name === "crm-view-work-order") {
    return true
  } else if (to.name === "crm-view-proposal") {
    return true
  } else if (to.name === 'requisition-view') {
    return true;
  } else if (to.name === 'employee-details') {
    return true;
  } else if (to.name === 'cnc-requisition-view'){
    return true;
  } else if (to.name === 'employee-formatted-letter'){
    return true;
  } else if (to.name === 'view-rfq-invoice') {
    return true;
  } else if (to.name === 'add-sale-invoice'){
    return true;
  } else if (to.name === 'add-purchase'){
    return true;
  } else if (to.name === 'view-journal-voucher'){
    return true;
  } else if (to.name === 'view-receipt-voucher'){
    return true;
  } else if (to.name === 'view-contra-voucher'){
    return true;
  } else if (to.name === 'view-payment-voucher'){
    return true;
  } else if (to.name === 'view-debit-note-voucher') {
    return true
  } else if (to.name === 'view-credit-note-voucher') {
    return true
  } else if (to.name === 'view-refund-receive-voucher') {
    return true
  } else if (to.name === 'view-refund-pay-voucher') {
    return true
  } else if (to.name === 'view-purchase-voucher') {
    return true
  } else if (to.name === 'view-sales-voucher') {
    return true
  } else if (to.name === 'view-opening-balance-voucher') {
    return true
  } else if (to.name === 'approval-request-record') {
    return true
  } else if (to.name === 'approval-process-preview') {
    return true
  } else if (to.name === 'view-gate-pass-invoice') {
    return true
  } else if (to.name === 'view-requisition-delivery-invoice') {
    return true
  } else if (to.name === 'view-sale-delivery-invoice') {
    return true
  } else if (to.name === 'view-issue-invoice') {
    return true
  } else if (to.name === 'view-requisition-invoice') {
    return true
  } else if (to.name === 'view-cnc-merge-invoice') {
    return true
  } else if (to.name === 'view-cs-quotation-invoice') {
    return true
  } else if (to.name === 'employee-weekend') {
    return true
  } else if (to.name === 'run-salary-process') {
    return true
  } else if (to.name === 'salary-process-details') {
    return true
  } else if (to.name === 'employee-salary-details-list') {
    return true
  } else if (to.name === 'employee-salary-details') {
    return true
  } else if (to.name === 'prepare-attendance') {
    return true
  } else if (to.name === 'attendance-summary') {
    return true
  } else if (to.name === 'attendance-summary-details') {
    return true
  } else if (to.path === '/payroll/salary-process') {
    return true
  } else if (to.name === 'vat-payemnt-details') {
    return true
  } else if (to.name === 'tax-payemnt-details') {
    return true
  } else if (to.name === 'view-payment-order-invoice') {
    return true
  } else if (to.name === 'employee-bonus-details-view') {
    return true
  } else if (to.name === 'bonus-process-report') {
    return true
  } else if (to.name === 'bonus-summary-register-report') {
    return true
  } else if (to.name === 'bonus-register-report') {
    return true
  } else if (to.name === 'employee-bonus-history-report') {
    return true
  } else if (to.name === 'bonus-comparative-report') {
    return true
  } else if (to.name === 'bonus-aging-report') {
    return true
  } else if (to.name === 'bonus-bank-advice') {
    return true
  } else if (to.name === 'bonus-trend-report') {
    return true
  } else if (to.name === 'bonus-payment-order-invoice') {
    return true
  } else if (to.name === 'transfer-record-view') {
    return true
  } else if (to.name === 'purchase-return-details') {
    return true
  } else if (to.name === 'sales-return-details') {
    return true
  } else if (to.name === 'lc-banks') {
    return true
  } else if (to.name === 'lc-bank-detail') {
    return true
  } else if (to.name === 'lc-payment-terms') {
    return true
  } else if (to.name === 'lc-incoterm') {
    return true
  } else if (to.name === 'lc-types') {
    return true
  } else if (to.name === 'lc-ports') {
    return true
  } else if (to.name === 'lc-shipping-methods') {
    return true
  } else if (to.name === 'lc-currency-echange-rate') {
    return true
  } else if (to.name === 'lc-import-register-report') {
    return true
  } else if (to.name === 'lc-import-register-report-page') {
    return true
  } else if (to.name === 'lc-import-shipment-report') {
    return true
  } else if (to.name === 'lc-import-shipment-report-page') {
    return true
  } else if (to.name === 'lc-import-aging-report') {
    return true
  } else if (to.name === 'lc-import-aging-report-page') {
    return true
  } else if (to.name === 'lc-import-supplier-wise-report') {
    return true
  } else if (to.name === 'lc-import-supplier-wise-report-page') {
    return true
  } else if (to.name === 'lc-import-bank-wise-report') {
    return true
  } else if (to.name === 'lc-import-bank-wise-report-page') {
    return true
  } else if (to.name === 'lc-import-pi-allocation-report') {
    return true
  } else if (to.name === 'lc-import-pi-allocation-report-page') {
    return true
  } else if (to.name === 'employee-roster-view') {
    return true
  } else if (to.name === 'buyer-order-view') {
    return true
  } else if (to.name === 'production-order-view') {
    return true
  } else if (to.name === 'view-cutting') {
    return true
  } else if (to.name === 'sewing-input-view') {
    return true
  } else if (to.name === 'sewing-output-view') {
    return true
  } else if (to.name === 'qc-view') {
    return true
  } else if (to.name === 'proforma-invoice-view') {
    return true
  } else if (to.name === 'invoice-bill-view') {
    return true
  } else if (to.name === 'export-lc-view') {
    return true
  } else if (to.name === 'export-commercial-invoice-view') {
    return true
  } else if (to.name === 'view-leave') {
    return true
  } else if (to.name === 'tt-allocation-view') {
    return true
  } else if (to.name === 'lc-import-lc-costing-view') {
    return true
  }

  

  


  

  
   else {
    let flag = false;
    var menusNotParsed = localStorage.getItem("menu");
    if (menusNotParsed) {
      var menus = JSON.parse(menusNotParsed);
      var menu = {};
      var menuChild = {};
      for (menu of menus) {
        if (!flag) {
          for (menuChild of menu.sub_module) {
            var child = {};
            if (!flag) {
              for(child of menuChild.menu){
                let menuLink = child.link;
                // let toLink = to.fullPath;
                let toLink = to.path;
                if (menuLink === toLink) {
                  flag = true;
                  break;
                }
              }
            }
            else{
              break;
            }
          }
        } else {
          break;
        }
      }
    }
    return flag;
  }
}


router.beforeEach((to, from, next) => {
 
  var isFalseSet = localStorage.getItem("guard") == "false";
  if (!isFalseSet) {
   
    try {
      if (!to.matched.length) {
        // next("/pageNotFound");
        next();
      } else {

        if (to.matched.some((record) => record.meta.UserLoggedIn)) {
          const token = localStorage.getItem("token");
          const expires = localStorage.getItem("user-expires");
            if (token && expires) {
            // if (ifRouteExist(to)) {
            //   next();
            // } else {
            //   next("/pageNotFound");             
            // }
            next();
          } else {
            next("/");
          }
        }  
        else {
          next();
        }


      }
    } catch (err) {
      console.log(err);
    }
  } else {
    next();
    console.log("in guard false");
  }
});


export default router
